import axios from 'axios';
import { Counter } from 'components/common/counter';
import { apiConfig } from 'config';
import {
    addCartItemExtra,
    removeCartItemExtra,
    updateCartItemExtra,
} from 'features/cart/cartSlice';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import './CartAddOn.css';

const CartAddOn = ({
    title,
    description,
    price,
    priceText,
    priceDescription,
    img,
    addOnText,
    addOnID,
    minQuantity,
    maxQuantity,
    quantity,
    isMobile = false,
}) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const searchOptions = useSelector((state) => state.user);

    const cartItems = useSelector((state) => state.cart?.cartItems);
    const firstIncompleteIndex = cartItems.findIndex(
        (item) => !item.isCompleted
    );
    const selectedItem =
        useSelector((state) => state.cart?.cartItems[firstIncompleteIndex]) ||
        {};
    const existingExtras =
        cartItems &&
        cartItems.find((cartItem) =>
            cartItem?.extras?.some(
                (item) =>
                    item.cartID === selectedItem?.cartID &&
                    item.rateID === selectedItem?.rateID &&
                    item.roomTypeID === selectedItem?.roomTypeID &&
                    item.addOnID === addOnID
            )
        );
    const thisExtra = existingExtras?.extras?.filter(
        (extra) =>
            extra.cartID === selectedItem?.cartID &&
            extra.addOnID === addOnID &&
            extra.rateID === selectedItem?.rateID &&
            extra.roomTypeID === selectedItem?.roomTypeID
    );
    const [amount, setAmount] = useState(
        thisExtra && thisExtra.length > 0 ? thisExtra[0].quantity : 1
    );
    const handleCounterChange = (key, value) => {
        setAmount(value);
    };

    const updateExtra =
        thisExtra && thisExtra.length > 0
            ? thisExtra[0].quantity !== amount
            : false;
    const addToCart = async (addOnID) => {
        const extra = {
            addOnID,
            rateID: selectedItem?.rateID,
            roomTypeID: selectedItem?.roomTypeID,
            title,
            price,
            img,
            quantity: amount,
            minQuantity: minQuantity,
            maxQuantity: maxQuantity,
            checkin: searchOptions?.checkInDay.date,
            checkout: searchOptions?.checkOutDay.date,
            cartID: selectedItem?.cartID,
            propCode: selectedItem?.hotelCode,
        };
        if (!existingExtras) {
            const response = await addCartItemExtraBack(extra);
            if (response.status === 'ok') {
                extra.ID = response.ID;
                dispatch(addCartItemExtra(extra));
            }
        } else {
            if (updateExtra) {
                const response = await updateCartItemExtraBack(extra);
                if (response.status === 'ok') {
                    extra.ID = response.ID;
                    dispatch(updateCartItemExtra(extra));
                }
            } else {
                if ((await removeFromCartExtraBack(thisExtra)) === 'ok')
                    dispatch(
                        removeCartItemExtra({
                            rateID: selectedItem?.rateID,
                            roomTypeID: selectedItem?.roomTypeID,
                            addOnID,
                        })
                    );
            }
        }
    };

    const removeFromCartExtraBack = async (extra) => {
        try {
            extra.cartID = selectedItem?.cartID;
            extra.propCode = selectedItem?.propCode;
            const response = await axios.post(
                apiConfig?.removeFromCartExtraBack,
                { ...extra[0] }
            );

            if (response?.data.toLowerCase() === 'ok') {
                return 'ok';
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const addCartItemExtraBack = async (extra) => {
        try {
            const response = await axios.post(apiConfig?.addCartItemExtraBack, {
                ...extra,
            });

            if (response?.data.status.toLowerCase() === 'ok') {
                return response?.data;
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    const updateCartItemExtraBack = async (extra) => {
        try {
            const response = await axios.post(
                apiConfig?.updateCartItemExtraBack,
                { ...extra }
            );

            if (response?.data.status.toLowerCase() === 'ok') {
                return response?.data;
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };

    return (
        <div
            className={`ab-cart-add-on-wrapper ${
                isMobile ? 'mobile-add-on-wrapper' : ''
            }`}
        >
            {!isMobile ? (
                <>
                    {' '}
                    <div className="ab-cart-add-on-title">{title}</div>
                    <div className="ab-cart-add-on-product">
                        <div className="ab-cart-add-on-img">
                            <img src={img} />
                        </div>
                        <div className="ab-cart-add-on-middle-right">
                            <div className="ab-cart-add-on-description">
                                {description}
                            </div>
                            <div className="ab-cart-add-on-amount">
                                {' '}
                                <Counter
                                    label={addOnText}
                                    initialValue={quantity > 0 ? quantity : 1}
                                    onChange={handleCounterChange}
                                    searchKey={'amount'}
                                    lowestValue={minQuantity}
                                    maxValue={maxQuantity}
                                />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="mobile-addon-card">
                    <div className="ab-cart-add-on-img">
                        <img src={img} />
                    </div>
                    <div className="ab-cart-add-on-title">{title}</div>
                    <div className="ab-cart-add-on-middle-right">
                        <div className="ab-cart-add-on-description">
                            {description}
                        </div>
                        <div className="ab-cart-add-on-amount">
                            {' '}
                            <Counter
                                label={addOnText}
                                initialValue={quantity > 0 ? quantity : 1}
                                onChange={handleCounterChange}
                                searchKey={'amount'}
                                lowestValue={minQuantity}
                                maxValue={maxQuantity}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="ab-cart-add-on-bottom">
                <div className="ab-cart-add-on-price">
                    <div className="ab-cart-add-on-price-top">
                        <span className="ab-cart-add-on-price-label">
                            {new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: searchOptions.currency,
                            })
                                .format(Number(price))
                                .replace(/(\D)(\d)/, '$1\u00A0$2')}
                        </span>
                        {priceText}
                    </div>
                    <div className="ab-cart-add-on-price-bottom">
                        {priceDescription}
                    </div>
                </div>
                <button
                    className={`ab-cart-add-on-add-button ${
                        existingExtras
                            ? updateExtra
                                ? 'ab-cart-add-on-update'
                                : 'ab-cart-add-on-remove'
                            : ''
                    }`}
                    onClick={() => addToCart(addOnID)}
                >
                    {existingExtras
                        ? updateExtra
                            ? Lang?.update
                            : Lang?.remove
                        : Lang?.select}
                </button>
            </div>
            <div className="ab-cart-separate-line"></div>
        </div>
    );
};

CartAddOn.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.string,
    priceText: PropTypes.string,
    priceDescription: PropTypes.string,
    img: PropTypes.string,
    addOnText: PropTypes.string,
    addOnID: PropTypes.number,
    minQuantity: PropTypes.number,
    maxQuantity: PropTypes.number,
    quantity: PropTypes.number,
    isMobile: PropTypes.bool,
};

export default CartAddOn;
